import { ModulesMap, ModulesConfigMap } from '../modulesMaps'

export default {
	[ModulesConfigMap[ModulesMap.REGULATIONS_STAGES_PLAN_WORKS_RECOMENDED_EQUIPMENT]
		.GET_REGULATIONS_STAGES_PLAN_WORKS_RECOMENDED_EQUIPMENT]: {
		url: '/company/:companyId/regulations/:regulationId/stages/:stageId/plan_works/:planWorkId/recommended_equipment/',
	},
}
